import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { FNOLPALossTypePage } from 'gwce-capability-fnol-pa-react-ext';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import wizardConfig from '../../config/fnol-wt-wizard-config.json5';

function FNOLWTLossTypePage(props) {
    return <FNOLPALossTypePage {...props}
        wizardConfig={wizardConfig}
    />;
} 

FNOLWTLossTypePage.propTypes = {
    viewModelService: PropTypes.shape({
        create: PropTypes.func,
    }).isRequired,
};

FNOLWTLossTypePage.propTypes = wizardProps;
export default withRouter(FNOLWTLossTypePage);